export const calculateShortDebt = (amount: number, term: number) => amount + (term * 0.8 * amount) / 100;
